import "./index.css";
import React from 'react';

interface TypeFormPreviewProps
  extends Partial<Record<"title" | "content", string>> {}

/**
 * @name FormPreview 表单预览文本组件
 */
const FormPreview: React.FC<TypeFormPreviewProps> = ({ title, content }) => (
  <div className="form-preview-text">
    <div className="form-preview-text-title">{title}</div>
    <div className="form-preview-text-content">{content}</div>
  </div>
);

export default FormPreview;
